export enum EmbeddedViewPath {
  HomepageSettings = 'homepagesettings',
  PortalBrandingSettings = 'portalbrandingsettings',
  WorkflowsAdminView = 'workflowsadmin',
  CustomTranslations = 'customtranslations',
}
